import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Material Details Cell Renderer
 *
 * Displays material information with code and name in a two-line format.
 * Code is displayed in small gray text, name in regular text.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'material',
 *   headerName: 'Material',
 *   cellRenderer: MaterialDetailsCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-material-details-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col text-sm whitespace-nowrap">
      <span class="table-text-code text-xs text-gray-500">
        {{ materialCode }}
      </span>
      <span>{{ materialName }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
    .table-text-code {
      font-family: 'Courier New', monospace;
    }
  `]
})
export class MaterialDetailsCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get materialCode(): string {
    return this.params.data?.material?.externalKeys?.code ?? '-';
  }

  get materialName(): string {
    return this.params.data?.material?.name ?? '-';
  }
}
